import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { LangProvider } from "./context/LangContext";
import { SEOHead } from "./components/SEOHead";

import LandingPage from "./pages/LandingPage";
import AppLayout from "./pages/app/AppLayout";
import MapView from "./pages/app/MapView";
import ChatView from "./pages/app/ChatView";
import DashboardView from "./pages/app/DashboardView";
import RouteView from "./pages/app/RouteView";
import ProfileView from "./pages/app/ProfileView";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LangProvider>
          <AuthProvider>
            <SEOHead />
            <Toaster
              theme="dark"
              position="top-center"
              toastOptions={{
                style: {
                  background: "#1c1c1e",
                  border: "1px solid rgba(255, 255, 255, 0.08)",
                  color: "#fff",
                },
              }}
            />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/ru" element={<LandingPage />} />
              <Route path="/en" element={<LandingPage />} />
              <Route path="/he" element={<LandingPage />} />
              <Route path="/app" element={<AppLayout />}>
                <Route index element={<MapView />} />
                <Route path="chat" element={<ChatView />} />
                <Route path="dashboard" element={<DashboardView />} />
                <Route path="route" element={<RouteView />} />
                <Route path="profile" element={<ProfileView />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </LangProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
